import { Component, OnInit } from '@angular/core';

import { PopoverController } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';

import { PopoverNotificacionesPage } from 'src/app/pages/popover-notificaciones/popover-notificaciones.page';
import { NotificacionesService } from 'src/app/services/notificaciones.service';

import { Subscription } from 'rxjs';

@Component({
  selector: 'app-notify-popover',
  templateUrl: './notify-popover.component.html',
  styleUrls: ['./notify-popover.component.scss'],
})
export class NotifyPopoverComponent implements OnInit {

  idAdmin: any;
  classUser: any;
  canal: any;
  canales: any;
  canalInicial: any;

  length: any;

  notifySubscription: Subscription;

  constructor(
    private storage: Storage,
    private popoverController: PopoverController,
    private notificacion: NotificacionesService) { }

  ngOnInit() {
    this.notifySubscription = this.notificacion.socketNotify().subscribe(() => {
      console.log('getNotification');
      this.getLength();
    });

    this.getCanal();
  }

  async getCanal() {
    this.canal = await this.storage.get('canal').then();
    this.canales = await this.storage.get('canales').then();
    this.canalInicial = this.canales.find(canal => canal.canale.idAdmin_sec === this.canal.idAdmin_sec);
    this.idAdmin = this.canalInicial.canale.idAdmin_sec;
    this.classUser = this.canalInicial;
    this.getLength();
  }

  getLength() {
    this.notificacion.getAllNotify(this.idAdmin, this.classUser.id, this.classUser.rol, this.classUser.token,
      this.classUser.canale.url_back, 0).subscribe((res: any) => {
        console.log('getNotification', res);

        const { status, datos } = res;

        if (status === 'success') {
          this.length = datos.length;
        }
      });
  }

  async openPopover(event: any) {
    const popover = await this.popoverController.create({
      component: PopoverNotificacionesPage,
      componentProps: { onChange: () => this.getLength() },
      event,
      translucent: true,
      cssClass: 'popover-content'
    });
    console.log('entro popover');
    return await popover.present();
  }

}
